import React from "react";
import styled from "styled-components";

const G = styled.g`
  stroke: ${props => props.theme.icon};
`;

const Path = styled.path`
  fill: ${props => (props.selected ? props.theme.icon : "none")};
`;

const Circle = styled.circle`
  fill: ${props => (props.selected ? props.theme.icon : "none")};
`;

const ServicesIcon = ({ selected }) => {
  if (window.innerWidth > 1800) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29.338"
        height="27.605"
        viewBox="0 0 29.338 27.605"
      >
        <G
          selected={selected}
          transform="translate(0 1)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
        >
          <g transform="translate(1.584 2.767)">
            <Path
              selected={selected}
              d="M16.252,26.687V21.336a7.176,7.176,0,1,0-14.352,0v5.351C1.892,26.687,8.018,29.546,16.252,26.687Z"
              transform="translate(-1.9 -5.125)"
            />
            <Circle
              selected={selected}
              cx="4.217"
              cy="4.217"
              r="4.217"
              transform="translate(2.959)"
            />
          </g>
          <g transform="translate(16.128)">
            <Path
              selected={selected}
              d="M30.135,17.165V14.523a5.393,5.393,0,1,0-10.785,0v2.65"
              transform="translate(-19.35 -2.354)"
            />
            <Circle
              selected={selected}
              cx="3.167"
              cy="3.167"
              r="3.167"
              transform="translate(2.225)"
            />
          </g>
          <line x1="2.909" transform="translate(0 14.819)" />
          <path
            d="M17.52,17.78H31.256V29.532"
            transform="translate(-2.918 -2.961)"
          />
        </G>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19.238"
        height="18.069"
        viewBox="0 0 19.238 18.069"
      >
        <G
          selected={selected}
          transform="translate(-18.5 -450.937)"
          strokeMiterlimit="10"
        >
          <Path
            selected={selected}
            d="M11.39,22.443V18.905a4.745,4.745,0,0,0-9.49,0v3.538A13.445,13.445,0,0,0,11.39,22.443Z"
            transform="translate(17.647 445.08)"
          />
          <Circle
            selected={selected}
            cx="2.789"
            cy="2.789"
            r="2.789"
            transform="translate(21.504 453.266)"
          />
          <Path
            selected={selected}
            d="M26.481,14.443V12.7a3.566,3.566,0,0,0-7.131,0v1.753"
            transform="translate(9.814 446.787)"
          />
          <Circle
            selected={selected}
            cx="2.094"
            cy="2.094"
            r="2.094"
            transform="translate(30.636 451.436)"
            fill="#fff"
          />
          <line x1="1.923" transform="translate(18.5 461.235)" />
          <path
            d="M17.52,17.78H26.6v7.771"
            transform="translate(10.636 443.455)"
            fill="none"
          />
        </G>
      </svg>
    );
  }
};

export default ServicesIcon;
